import React, { useReducer } from 'react';
import Table from 'UI/Table';
import { humanizeGB, humanizeMB } from 'Decorators/SizeDecorator'
import { compact, findIndex, get, isNil, find } from 'lodash'
import AssetNameWithLabel from 'FoundationalComponents/AssetNameWithLabel'

const VMTable = ({ vms, showLocation = true, billing, vmsToUpdate, updateVMs }) => {
  const [, forceUpdate] = useReducer(x => x + 1, 0)
  const updateVM = (original, newValue) => {
    updateVMs(updatedVMs(vmsToUpdate, original, newValue.target.checked))
    forceUpdate()
  }

  return (
    <Table
      data={vms}
      columns={compact([
        (billing && {
          Header: 'Billable',
          className: 'react-table-capacity-vm-cell',
          accessor: 'billable',
          Cell: ({ value, original }) => (
            <input
              type="checkbox"
              checked={findVMBillableValue(vmsToUpdate, original, value)}
              name={`vm_billable_${original.id}`}
              id={`vm_billable_${original.id}`}
              onChange={newValue => updateVM(original, newValue)}
            />
          )
        }),
        (showLocation && { Header: 'Location', className: 'react-table-capacity-vm-cell', accessor: 'location_name' }),
        { Header: 'VM', className: 'react-table-capacity-vm-cell', accessor: 'name', width: 400, Cell: ({ value, original }) => (<AssetNameWithLabel name={value} label={original.asset_label} />) },
        { Header: 'Last Logged On User', className: 'react-table-capacity-vm-cell', accessor: 'lastLoggedOnUser' },
        { Header: 'Power State', className: 'react-table-capacity-vm-cell', accessor: 'power_state', type: 'powerState' },
        { Header: 'Number of CPUs', className: 'react-table-capacity-vm-cell', accessor: 'num_cpu', type: 'number' },
        { Header: 'Memory', className: 'react-table-capacity-vm-cell', accessor: 'memory_gb', type: 'number', Cell: ({ value }) => humanizeGB(value) },
        { Header: 'Memory (Reserved)', className: 'react-table-capacity-vm-cell', accessor: 'memory_reservation_mb', type: 'number', Cell: ({ value }) => humanizeMB(value) },
        { Header: 'Allocated Space', className: 'react-table-capacity-vm-cell', accessor: 'allocated_space_gb', type: 'number', Cell: ({ value }) => humanizeGB(value) },
        { Header: 'Provisioned Space', className: 'react-table-capacity-vm-cell', accessor: 'provisioned_space_gb', type: 'number', Cell: ({ value }) => humanizeGB(value) },
        { Header: 'Used Space', className: 'react-table-capacity-vm-cell', accessor: 'used_space_gb', type: 'number', Cell: ({ value }) => humanizeGB(value) },
      ])}
      tableProps={{
        defaultPageSize: vms.length,
        defaultSorted: [{ id: 'name', asc: true }],
        showPagination: false
      }} />
  )
}

const findVMBillableValue = (vmsToUpdate, original, originalValue) => {
  const vm = find(vmsToUpdate, ['id', original.id])

  if (isNil(vm)) {
    return originalValue
  } else {
    return get(vm, 'billable')
  }
}

const findVMToUpdate = (vms, vmId) => {
  const vmToUpdateIndex = findIndex(vms, ['id', vmId])

  return vms[vmToUpdateIndex]
}

const updatedVMs = (vms, vm, newValue) => {
  const vmToUpdate = findVMToUpdate(vms, vm.id)

  if (vmToUpdate) {
    vmToUpdate.billable = newValue
  } else {
    vms.push({ ...vm, billable: newValue })
  }

  return vms
}

export default VMTable
